import { CycleDetailPage } from '@/components/billing/cycle-detail-page'

export function OperationsBillingCycleDetail() {
  return <CycleDetailPage basePath="/operations/billing" />
}
